/* bs-videos-maison.js — section vidéo maison B&S (remplace Vidjet), 2026-10-20.
   Aucune dépendance. Poster chargé à l'approche (600 px), vidéo d'aperçu chargée et jouée seulement
   quand elle entre à l'écran (marge 150 px), mise en pause dès qu'elle sort. Au tap : lecteur plein écran
   vertical (version 720 px avec le son), balayage haut/bas ou flèches pour passer à la suivante. */
(function () {
  if (window.__bsv) return; window.__bsv = 1;
  var calme = false;
  try {
    calme = matchMedia('(prefers-reduced-motion: reduce)').matches || !!(navigator.connection && navigator.connection.saveData);
  } catch (e) {}
  var lecOn = false, ov, vid, list = [], idx = 0;

  function joue(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  // 21/10 : posters chargés tôt (1 500 px avant), vidéo lancée seulement quand SON poster est prêt,
  // au plus 2 vidéos d'aperçu en téléchargement à la fois (sinon les posters arrivent après coup, cartes « à moitié dessinées »).
  var actifs = 0, file = [];
  function suivante() {
    while (actifs < 2 && file.length) {
      var v = file.shift();
      if (v.__bsvQ !== 1 || lecOn || calme) { v.__bsvQ = 0; continue; }
      v.__bsvQ = 2; actifs++;
      var fini = function (x) { return function () { if (x.__bsvQ === 2) { x.__bsvQ = 3; actifs--; suivante(); } }; }(v);
      v.addEventListener('loadeddata', fini, { once: true }); v.addEventListener('error', fini, { once: true });
      setTimeout(fini, 8000);
      if (!v.getAttribute('src')) v.src = v.dataset.src;
      if (v.__bsvVu) joue(v);
    }
  }
  function demande(v) {
    if (calme || lecOn) return;
    if (v.__bsvQ >= 2) { if (v.getAttribute('src')) joue(v); return; }
    if (!v.__bsvPosterOk) { v.__bsvAttend = 1; return; }
    if (v.__bsvQ !== 1) { v.__bsvQ = 1; file.push(v); }
    suivante();
  }
  function poster(v) {
    if (v.__bsvPosterDemande) return; v.__bsvPosterDemande = 1;
    // poster à la taille réelle de la tuile (CDN Shopify ?width=), affiché seulement une fois décodé entier (jamais à moitié)
    var u = v.dataset.poster;
    if (!/[?&]width=/.test(u)) {
      var w = Math.ceil((v.getBoundingClientRect().width || 200) * Math.min(window.devicePixelRatio || 1, 3) / 60) * 60;
      // au-delà de ~400 px, le fichier d'origine (540 px) est plus léger que la version recalculée par le CDN (mesuré 21/10)
      if (w < 420) u += (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + Math.max(w, 120);
    }
    var im = new Image(); im.decoding = 'async';
    im.onload = im.onerror = function () { v.poster = u; v.__bsvPosterOk = 1; if (v.__bsvAttend && v.__bsvVu) demande(v); };
    im.src = u;
  }

  function init(root) {
    if (root.__bsv) return; root.__bsv = 1;
    var vids = root.querySelectorAll('video[data-src]');
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.poster = v.dataset.poster; });
    } else {
      var ioPoster = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { poster(e.target); ioPoster.unobserve(e.target); } });
      }, { rootMargin: '1500px 1500px' });
      var ioVid = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          v.__bsvVu = e.isIntersecting;
          if (e.isIntersecting) { poster(v); demande(v); }
          else { if (v.__bsvQ === 1) v.__bsvQ = 0; if (v.getAttribute('src')) v.pause(); }
        });
      }, { rootMargin: '150px 150px', threshold: 0.01 });
      vids.forEach(function (v) { ioPoster.observe(v); ioVid.observe(v); });
      root.__bsvVis = function (v) { var r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth; };
    }
    root.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      var b = ev.target.closest('[data-bsv-i]');
      if (b) { ev.preventDefault(); ouvre(root, +b.getAttribute('data-bsv-i')); }
    });
    root.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-bsv-i]');
      if (!b) return;
      ev.preventDefault();
      ouvre(root, +b.getAttribute('data-bsv-i'));
    });
  }

  function construit() {
    ov = document.createElement('div');
    ov.className = 'bsv-lec';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.innerHTML = '<video playsinline controls preload="none"></video>' +
      '<button type="button" class="bsv-lec__x" aria-label="Close">&times;</button>' +
      '<button type="button" class="bsv-lec__p" aria-label="Previous">&lsaquo;</button>' +
      '<button type="button" class="bsv-lec__n" aria-label="Next">&rsaquo;</button>';
    document.body.appendChild(ov);
    vid = ov.querySelector('video');
    ov.querySelector('.bsv-lec__x').addEventListener('click', ferme);
    ov.querySelector('.bsv-lec__p').addEventListener('click', function () { va(idx - 1); });
    ov.querySelector('.bsv-lec__n').addEventListener('click', function () { va(idx + 1); });
    vid.addEventListener('ended', function () { va(idx + 1); });
    var y0 = null;
    ov.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
    ov.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var dy = e.changedTouches[0].clientY - y0; y0 = null;
      if (Math.abs(dy) > 60) va(idx + (dy < 0 ? 1 : -1));
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!lecOn) return;
      if (e.key === 'Escape') ferme();
      else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') va(idx + 1);
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') va(idx - 1);
    });
  }

  function ouvre(root, i) {
    if (!ov) construit();
    list = [].map.call(root.querySelectorAll('[data-bsv-i]'), function (b) {
      return { src: b.getAttribute('data-lec'), poster: b.getAttribute('data-poster') };
    });
    lecOn = true;
    document.querySelectorAll('[data-bsv] video').forEach(function (v) { v.pause(); });
    ov.classList.add('is-on');
    document.documentElement.classList.add('bsv-lock');
    va(i);
  }

  function va(i) {
    if (i < 0) return;
    if (i >= list.length) { ferme(); return; }
    idx = i;
    vid.poster = list[i].poster;
    vid.src = list[i].src;
    vid.muted = false;
    var p = vid.play();
    if (p && p.catch) p.catch(function () { vid.muted = true; joue(vid); });
  }

  function ferme() {
    lecOn = false;
    ov.classList.remove('is-on');
    document.documentElement.classList.remove('bsv-lock');
    vid.pause(); vid.removeAttribute('src'); vid.load();
    document.querySelectorAll('[data-bsv]').forEach(function (r) {
      if (!r.__bsvVis || calme) return;
      r.querySelectorAll('video[data-src]').forEach(function (v) {
        if (!r.__bsvVis(v)) return;
        if (v.getAttribute('src')) joue(v); else { if (v.__bsvQ === 1) v.__bsvQ = 0; demande(v); }
      });
    });
  }

  function tout() { document.querySelectorAll('[data-bsv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
})();
